import { Button } from '@common/ui'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/web'
import EntityFieldDisplayGroup from '../shared/EntityFieldDisplayGroup'
import PageLayout from '../shared/PageLayout'
import { KindViewPageProps } from '../KindPages'
import useHasPermission from '../../../permission/useHasPermission'
import EntityAction = com.eidu.entity.permission.EntityAction

const DefaultViewPage = ({ entity, entityType, fields }: KindViewPageProps) => {
  const navigate = useNavigate()
  const navigateToEdit = () => {
    navigate(`/entities/${entityType.id.toString()}/edit/${entity.entity.id.toString()}`)
  }

  const { hasPermission: hasUpdatePermission } = useHasPermission(entity.entity.id, EntityAction.UpdateEntity)

  return (
    <PageLayout
      title={entity.primaryLabelText}
      subtitle={entityType.name}
      auditTargetId={entity.entity.id.toString()}
      actions={
        hasUpdatePermission ? (
          <Button variant="subtle" onClick={navigateToEdit}>
            Edit
          </Button>
        ) : undefined
      }
      showBack
    >
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingTop: 12 }}>
        <EntityFieldDisplayGroup entityType={entityType} fields={fields} entityId={entity.entity.id} />
      </div>
    </PageLayout>
  )
}

export default DefaultViewPage
